module.exports = __webpack_public_path__ + "static/media/mern-stack.2d890712.jpg";